module.exports = __webpack_public_path__ + "img/停用.3c8ef1de.svg";